import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { GoogleButton } from '../components/shared/GoogleButton';
import { Footer } from '../components/shared/Footer';

export const Register = () => {
  const navigate = useNavigate();
  const { register, isLoading, error } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [localError, setLocalError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLocalError(null);
    if (password !== passwordConfirm) {
      setLocalError('Les deux mots de passe ne correspondent pas');
      return;
    }
    try {
      await register({ email, password });
      navigate('/dashboard');
    } catch {
      /* erreur affichée via useAuth().error */
    }
  };

  const displayError = localError ?? error;

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-semibold text-neutral-900">Falko</h1>
          <p className="mt-2 text-sm text-neutral-500">Crée ton espace en 30 secondes</p>
        </div>
        <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 p-6 space-y-4">
          <GoogleButton label="S'inscrire avec Google" />
          <div className="flex items-center gap-3 text-xs text-neutral-400">
            <span className="flex-1 border-t border-neutral-200" />
            <span>ou avec ton email</span>
            <span className="flex-1 border-t border-neutral-200" />
          </div>
          <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-neutral-700 mb-1">
              Adresse email
            </label>
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
              placeholder="toi@exemple.com"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-neutral-700 mb-1">
              Mot de passe (8 caractères minimum)
            </label>
            <input
              id="password"
              type="password"
              required
              minLength={8}
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
              placeholder="••••••••"
            />
          </div>
          <div>
            <label htmlFor="passwordConfirm" className="block text-sm font-medium text-neutral-700 mb-1">
              Confirmation du mot de passe
            </label>
            <input
              id="passwordConfirm"
              type="password"
              required
              minLength={8}
              autoComplete="new-password"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              className="w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
              placeholder="••••••••"
            />
          </div>
          {displayError && (
            <div className="rounded-lg bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">
              {displayError}
            </div>
          )}
          <button
            type="submit"
            disabled={isLoading}
            className="w-full rounded-lg bg-violet-600 text-white py-2 text-sm font-medium hover:bg-violet-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
          >
            {isLoading ? 'Création…' : 'Créer mon compte'}
          </button>
          </form>
        </div>
        <p className="mt-6 text-center text-sm text-neutral-600">
          Déjà un compte ?{' '}
          <Link to="/login" className="text-violet-600 hover:text-violet-700 font-medium">
            Se connecter
          </Link>
        </p>
        <Footer />
      </div>
    </div>
  );
};
